document.addEventListener('click', event => {
    const target = event.target;
    const $slider = target.closest('.js-product-slider');

    if($slider) {
        const width = $slider.querySelector('.product-slider__track').querySelector('div').clientWidth;

        if(target.classList.contains('js-slider-next') || target.parentElement.classList.contains('js-slider-next') ) {
            $slider.querySelector('.product-slider__track').scrollLeft += width;
        }else if(target.classList.contains('js-slider-prev') || target.parentElement.classList.contains('js-slider-prev') ){
            $slider.querySelector('.product-slider__track').scrollLeft -= width;
        }
    }
});
